import { createGlobalState } from "react-hooks-global-state";

const { setGlobalState, useGlobalState } = createGlobalState({
  ws: null,
});

export { useGlobalState, setGlobalState };
